export function buildDepartTree (rows, parentId) {
  if (rows == null || rows.length == 0) {
      return []
  }
  const result = []
  for (let row of rows) {
      if ((parentId == null && row.parentId == null) || (parentId != null && row.parentId == parentId)) {
          if (row.id == null) {
              continue
          }
          const parent = row
          const subRows = rows.filter(item => item.id != row.id)
          const children = buildDepartTree(subRows, parent.id)
          if (children != null && children.length > 0) {
              parent.children = children
          }
          result.push(parent)
      }
  }
  return result
}